import Smile from "assets/icons/custom-assignments/face-smile.svg";
import Frown from "assets/icons/custom-assignments/face-frown.svg";
import Meh from "assets/icons/custom-assignments/face-meh.svg";
import GrinBeam from "assets/icons/custom-assignments/face-grin-beam.svg";
import GrinTears from "assets/icons/custom-assignments/face-grin-tears.svg";
import GrinHearts from "assets/icons/custom-assignments/face-grin-hearts.svg";
import Heart from "assets/icons/custom-assignments/heart.svg";
import Sun from "assets/icons/custom-assignments/sun.svg";
import Moon from "assets/icons/custom-assignments/moon.svg";
import Cloud from "assets/icons/custom-assignments/cloud.svg";
import Umbrella from "assets/icons/custom-assignments/umbrella.svg";
import Star from "assets/icons/custom-assignments/star.svg";
import Leaf from "assets/icons/custom-assignments/leaf.svg";
import Running from "assets/icons/custom-assignments/person-running.svg";
import Hiking from "assets/icons/custom-assignments/person-hiking.svg";
import Yoga from "assets/icons/custom-assignments/person-praying.svg";
import Stethoscope from "assets/icons/custom-assignments/stethoscope.svg";
import Brain from "assets/icons/custom-assignments/brain.svg";
import Comments from "assets/icons/custom-assignments/comments.svg";
import BookOpen from "assets/icons/custom-assignments/book-open.svg";
import Books2 from "assets/icons/books2.svg";
import Music from "assets/icons/custom-assignments/music.svg";
import Pen from "assets/icons/custom-assignments/pen.svg";
import PaintBrush from "assets/icons/custom-assignments/paintbrush.svg";
import Lightbulb from "assets/icons/custom-assignments/lightbulb.svg";
import PuzzlePiece from "assets/icons/custom-assignments/puzzle-piece.svg";
import Mountain from "assets/icons/custom-assignments/mountain.svg";
import HandsHelping from "assets/icons/custom-assignments/hands-holding-circle.svg";
import ThumbsUp from "assets/icons/custom-assignments/thumbs-up.svg";
import ThumbsDown from "assets/icons/custom-assignments/thumbs-down.svg";
import LifeRing from "assets/icons/custom-assignments/life-ring.svg";

import ThoughtRecord from "assets/icons/waveform-path.svg";
import MoodTracker from "assets/icons/cloud-rainbow.svg";
import JournalIcon from "assets/icons/book-spells.svg";
import SafetyPlanIcon from "assets/icons/lifebuoy.svg";
import GratitudeJournalIcon from "assets/icons/book-heart.svg";
import SocraticQuestionsIcon from "assets/icons/map-marker-question.svg";
import CognitiveRestructuringIcon from "assets/icons/brain.svg";
import CognitiveTriangleIcon from "assets/icons/recycle.svg";
import GoalJournalIcon from "assets/icons/atlas.svg";
import WorryJournalIcon from "assets/icons/temperature-high.svg";
import UpcomingSessionIcon from "assets/icons/calendar-circle-user.svg";
import PostSessionIcon from "assets/icons/memo-pad.svg";
import SensesExerciseIcon from "assets/icons/5.svg";
import ArrowDown from "assets/icons/angle-down.svg";

import DraftIcon from "assets/icons/pen-ruler.svg";

import Schedule from "assets/icons/workbook-buttons/schedule.svg";
import Configure from "assets/icons/workbook-buttons/configure.svg";
import Preview from "assets/icons/workbook-buttons/preview.svg";
import Remove from "assets/icons/workbook-buttons/remove.svg";
import ChangeIcon from "assets/icons/workbook-buttons/change-icon.svg";
import EditIcon from "assets/icons/pen-to-square.svg";
import EditIconBold from "assets/icons/pen-to-square-bold.svg";
import CancelArrow from "assets/icons/workbook-buttons/cancel-arrow.svg";
import HideIcon from "assets/icons/workbook-buttons/hide-icon.svg";

import ArrowBack from "assets/icons/arrow-back.svg";
import ArrowLeftBold from "assets/icons/arrow-left-bold.svg";
import ArrowRightBold from "assets/icons/arrow-right-bold.svg";
import DownArrow from "assets/icons/down-arrow.svg";

import Bell from "assets/icons/bell.svg";

import Puzzle from "assets/icons/puzzle-piece.svg";
import Rook from "assets/icons/chess-rook-piece.svg";
import Gamer from "assets/icons/gamepad-modern.svg";
import Dice from "assets/icons/dice.svg";
import DandD from "assets/icons/dice-d20.svg";
import Robot from "assets/icons/robot.svg";
import Clover from "assets/icons/clover.svg";
import Gameboy from "assets/icons/game-console-handheld.svg";
import Castle from "assets/icons/castle.svg";
import Ghost from "assets/icons/ghost.svg";
import Icecream from "assets/icons/ice-cream.svg";
import Apple from "assets/icons/apple-whole.svg";
import Snowman from "assets/icons/snowman.svg";
import Unicorn from "assets/icons/unicorn.svg";
import Whale from "assets/icons/whale.svg";
import Mitten from "assets/icons/mitten.svg";
import Truck from "assets/icons/truck.svg";
import Car from "assets/icons/car.svg";
import Bus from "assets/icons/bus-simple.svg";
import Cactus from "assets/icons/cactus.svg";
import Football from "assets/icons/football.svg";
import Bowling from "assets/icons/bowling-ball.svg";
import Helmet from "assets/icons/football-helmet.svg";
import Flag from "assets/icons/flag.svg";
import Rocket from "assets/icons/rocket.svg";
import Bulb from "assets/icons/lightbulb.svg";
import Guitar from "assets/icons/guitar.svg";
import Candycane from "assets/icons/candy-cane.svg";
import Carrot from "assets/icons/carrot.svg";
import Glasses from "assets/icons/glasses-round.svg";
import Cowboy from "assets/icons/hat-cowboy-side.svg";
import Television from "assets/icons/tv-retro.svg";

import Trash from "assets/icons/trash.svg";
import TrashBold from "assets/icons/trash2.svg";

import Link from "assets/icons/link.svg";
import Link2 from "assets/icons/link2.svg";
import Copy from "assets/icons/copy.svg";
import Copy2 from "assets/icons/copy2.svg";
import Copy3 from "assets/icons/copy3.svg";
import Print2 from "assets/icons/print2.svg";

import Envelope from "assets/icons/envelope.svg";
import IdCard from "assets/icons/id-card.svg";
import IdCard2 from "assets/icons/id-card-2.svg";

import FileBold from "assets/icons/filetypes/file-bold.svg";

import CloseCross from "assets/icons/close-cross.svg";
import CloseCrossBold from "assets/icons/crossBold.svg";

import Check from "assets/icons/check.svg";
import CheckBold from "assets/icons/check2.svg";
import CircleCheck from "assets/icons/circle-check.svg";
import Share from "assets/icons/share.svg";
import BirthDayCake2 from "assets/icons/birthday-cake2.svg";
import GenderIcon from "assets/icons/gender-icon.svg";
import ExternalLink from "assets/icons/external-link.svg";
import CollectionIcon from "assets/icons/collection.svg";
import InboxThin from "assets/icons/inbox-thin.svg";
import Inbox2 from "assets/icons/inbox2.svg";
import Search from "assets/icons/magnifying-glass.svg";
import Archive from "assets/icons/archive.svg";
import Warning from "assets/icons/exclamation-triangle.svg";
import Restore from "assets/icons/restore.svg";
import Group from "assets/icons/users.svg";
import Group2 from "assets/icons/group.svg";
import Image2 from "assets/icons/image2.svg";
import Warning2 from "assets/icons/exclamation-triangle2.svg";
import FillForm from "assets/icons/fill-form.svg";
import MenuDots from "assets/icons/ellipsis-vertical.svg";
import FileArrow from "assets/icons/file-arrow.svg";
import AddPatient from "assets/icons/users-medical.svg";
import AddPatientBold from "assets/icons/users-medical-bold.svg";
import UserChecked from "assets/icons/user-checked.svg";
import Report from "assets/icons/report.svg";
import Calendar2 from "assets/icons/calendar2.svg";
import Filter from "assets/icons/filter.svg";
import Export from "assets/icons/export.svg";
import DownArrow2 from "assets/icons/down-arrow2.svg";

const iconMap: any = {
  Smile,
  Frown,
  Meh,
  GrinBeam,
  GrinTears,
  GrinHearts,
  Heart,
  Sun,
  Moon,
  Cloud,
  Umbrella,
  Star,
  Leaf,
  Running,
  Hiking,
  Yoga,
  Stethoscope,
  Brain,
  Comments,
  BookOpen,
  Books2,
  Music,
  Pen,
  PaintBrush,
  Lightbulb,
  PuzzlePiece,
  Mountain,
  HandsHelping,
  ThumbsUp,
  ThumbsDown,
  LifeRing,
  ThoughtRecord,
  MoodTracker,
  JournalIcon,
  SafetyPlanIcon,
  GratitudeJournalIcon,
  SocraticQuestionsIcon,
  CognitiveRestructuringIcon,
  CognitiveTriangleIcon,
  GoalJournalIcon,
  WorryJournalIcon,
  UpcomingSessionIcon,
  PostSessionIcon,
  SensesExerciseIcon,
  DraftIcon,
  ArrowDown,
  Schedule,
  Configure,
  Preview,
  Remove,
  ChangeIcon,
  EditIcon,
  EditIconBold,
  CancelArrow,
  HideIcon,
  ArrowBack,
  ArrowLeftBold,
  ArrowRightBold,
  Bell,
  Puzzle,
  Rook,
  Gamer,
  Dice,
  DandD,
  Robot,
  Clover,
  Gameboy,
  Castle,
  Ghost,
  Icecream,
  Apple,
  Snowman,
  Unicorn,
  Whale,
  Mitten,
  Truck,
  Car,
  Bus,
  Cactus,
  Football,
  Bowling,
  Helmet,
  Flag,
  Rocket,
  Bulb,
  Guitar,
  Candycane,
  Carrot,
  Glasses,
  Cowboy,
  Television,
  Trash,
  TrashBold,
  Link,
  Link2,
  Copy,
  Copy2,
  Copy3,
  Print2,
  Envelope,
  IdCard,
  IdCard2,
  FileBold,
  CloseCross,
  Check,
  CheckBold,
  CircleCheck,
  CloseCrossBold,
  Share,
  BirthDayCake2,
  GenderIcon,
  ExternalLink,
  CollectionIcon,
  InboxThin,
  Inbox2,
  Search,
  Archive,
  Warning,
  Restore,
  Group,
  Group2,
  Image2,
  Warning2,
  FillForm,
  MenuDots,
  FileArrow,
  AddPatient,
  AddPatientBold,
  UserChecked,
  DownArrow,
  Report,
  Calendar2,
  Filter,
  Export,
  DownArrow2,
};

export default iconMap;
